
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.98 22a1 1 0 10-2 0 1 1 0 002 0zm3.2.166a1 1 0 10-.749-1.854 1 1 0 00.75 1.854zm-7.107-.537a1 1 0 10-1.841-.78 1 1 0 001.84.78zm-2.75-1.144a2 2 0 10-2.83-2.828 2 2 0 002.83 2.828zm13.434-.707a1 1 0 10-1.414-1.414 1 1 0 001.414 1.414zm2.381-3.56a1 1 0 10-1.84-.782 1 1 0 001.84.782zm-19.007.53a1 1 0 10-.781-1.842 1 1 0 00.781 1.841zM22.98 12a1 1 0 10-2 0 1 1 0 002 0zm-20 0a1 1 0 10-2 0 1 1 0 002 0zm18.614-2.9a1 1 0 10-.75-1.854 1 1 0 00.75 1.854zM3.66 8.564a1 1 0 10-1.841-.782 1 1 0 001.84.782zm16.803-2.22a2 2 0 10-2.828-2.83 2 2 0 002.828 2.83zM5.615 5.635a1 1 0 10-1.414-1.414 1 1 0 001.414 1.414zm2.912-1.948a1 1 0 10-.75-1.854 1 1 0 00.75 1.854zm6.888-.006a1 1 0 10.782-1.841 1 1 0 00-.782 1.84zM12.98 2a1 1 0 10-2 0 1 1 0 002 0zm1.346 10.88a3.004 3.004 0 10-4.692 0l.003.005c.058.071.113.146.168.22l.084.114c.146.194.352.465.59.777.446.582 1.002 1.3 1.502 1.916a92.04 92.04 0 001.504-1.919 137.121 137.121 0 00.684-.904c.052-.07.103-.14.157-.208zm.778.625l-.001.002c-.026.034-.26.347-.599.792a95.003 95.003 0 01-1.866 2.382.844.844 0 01-1.315 0 113.962 113.962 0 01-2.462-3.173l-.004-.004a4 4 0 116.248-.003l-.001.002h-.001.002v.002zm-3.124-2.021a.498.498 0 100-.996.498.498 0 000 .996zm1.493-.498a1.493 1.493 0 11-2.987 0 1.493 1.493 0 012.987 0z","fill":"currentColor"}})])
          )
        }
      }
    